
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/program/bootcamp",
      function () {
        return require("private-next-pages/program/bootcamp/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/program/bootcamp"])
      });
    }
  